<template>
  <div class="row mt-2">
    <div class="col">
      <div v-if="data">
        <rem-info
          :data="data"
          :userActions="userActions"
          v-if="view == 'detail'"
          @cancel="view = 'cancel'"
          @mobileSign="sendRemWithMobileSign"
          @showFinalizerDetail = "showFinalizerDetail"
        ></rem-info>
        <rem-cancel
        :data="data"
        :userActions="userActions"
        v-if="view == 'cancel'"
        @back="view = 'detail'"
        @cancel="cancel"
        ></rem-cancel>
        <finalizer-detail
        :data="finalizerDataToShow"
        :userActions="userActions"
        v-if="view == 'finalizerDetail'"
        @back="view = 'detail'"
        ></finalizer-detail>
        <job-mobile-sign
          :data="data"
          :isRem="true"
          :rem-signing-items="remSigningItems"
          :rem-finalizer="remFinalizer"
          v-if="view == 'sign'"
          @cancel="view = 'detail'"
        ></job-mobile-sign>
      </div>
      <div v-else>
        <h3 class="text-center text-muted mt-5">Yükleniyor...</h3>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import RemInfo from "../components/RemInfo.vue";
import RemCancel from '../components/RemCancel.vue'
import JobMobileSign from "../components/JobMobileSign.vue";
import FinalizerDetail from '../components/FinalizerDetail.vue'
export default {
  components: {
    RemInfo,
    RemCancel,
    JobMobileSign,
    FinalizerDetail
  },
  data() {
    return {
      data: null,
      userActions: null,
      view: "detail",
      remSigningItems: null,
      remFinalizer: null,
      finalizerDataToShow: null,
    };
  },
  methods: {
    showFinalizerDetail(finalizer){
      this.view = 'finalizerDetail'
      console.log("finalizer",finalizer)
      this.finalizerDataToShow = finalizer
    },
    sendRemWithMobileSign(mobileItems, sendRemFinalizer){
      console.log("mobileItems",mobileItems)
      console.log("sendremfinalizer",sendRemFinalizer)
      this.remSigningItems = mobileItems
      this.remFinalizer = sendRemFinalizer
      this.view = 'sign'
    },
    getData() {
      axios.get("/job/getwithactions/" + this.$route.params.id).then(x => {
        if (x.data.Success) {
          console.log("Gelen veri: ", x);
          this.data = x.data.Data.Job;
          this.userActions = x.data.Data.UserActions;
        }
      });
    },
    cancel(description) {
      return axios
        .post("/job/cancel", { JobId: this.data.Id, description: description })
        .then(x => {
          console.log("POST Result:", x.data);

          if (x.data.Success) {
            this.data = x.data.Data.Job;
            this.userActions = x.data.Data.UserActions;
            this.view = "detail";
          } else {
            this.$izonayAlert(x.data.ErrorMessages);
          }
        })
        .catch(x => window.processErrorResponse(x, this));
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style scoped>
.table.ozet > tbody > tr > td {
  padding: 1px 3px;
}

.table.ozet > tbody > tr > td:first-child {
  color: #666;
  padding-left: 0;
  white-space: nowrap;
}

.table.ozet > tbody > tr > td:nth-child(2) {
  font-weight: bold;
  width: 1px;
}

.commands {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.commands .btn {
  border-radius: 0;
}
</style>
